import { Button, Menu, MenuItem } from "@mui/material";
import DownloadIcon from "assets/icons/DownloadIcon";
import ExcelIcon from "assets/icons/ExcelIcon";
import PdfIcon from "assets/icons/PdfIcon";
import { useState } from "react";

export interface ExportProps {
  downloadTable:(type:'excel'|'pdf')=>void
}
export default function Export(props: ExportProps) {
  const {downloadTable}=props
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  return (
    <>
      <Button
        style={{ border: "1px solid #1062D0", minWidth: 40, minHeight: 40, borderRadius: 4 }}
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        <DownloadIcon color="#1062D0" />
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        sx={{ left: "20px" }}
        style={{ borderRadius: "4px" }}
        MenuListProps={{ style: { padding: 0 } }}
        // transformOrigin={{ horizontal: "left", vertical: "bottom" }}
        disableScrollLock
      >
        <MenuItem style={{ justifyContent: "space-between", gap: 12 }} onClick={() => {downloadTable("excel")}}>
          <span>Excel</span>
          <ExcelIcon color="#24AF22" />
        </MenuItem>
        <MenuItem style={{ justifyContent: "space-between", gap: 12 }} onClick={() => {}}>
          <span>PDF</span>
          <PdfIcon color="#CB0B0B" />
        </MenuItem>
      </Menu>
    </>
  );
}
